var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content min-vh-100 flex-column d-flex justify-content-between"},[_c('section',[_c('h2',{staticClass:"title"},[_vm._v("CONTACT US")]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Message Sent!")]),_c('p',[_vm._v("Thank you for reaching out. We will reply as soon as possible.")])])])])])
}]

export { render, staticRenderFns }